import DeleteIcon from "@mui/icons-material/Delete";
import { Box, IconButton, Tooltip } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { useSelector } from "react-redux";
import { StyledProvider } from "../../styled/providers";
import { tableConfig } from "./config/tableConfig";
import TitleContainer from "./utilsTable/titleWithFetchData";

const ProviderInUserTable = ({ data, handleDelete }) => {
  const esSoporte = useSelector(
    (state) => state.auth.roles?.tipo === "Soporte",
  );

  const columns = [
    {
      header: "Prestador",
      accessorKey: "nombre",
    },
    {
      header: "Acciones",
      id: "acciones",
      Cell: ({ row }) => (
        <Box display="flex">
          <Tooltip title="Eliminar Prestador">
            <IconButton
              color="inherit"
              onClick={() => handleDelete(row.original)}
              disabled={esSoporte}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  return (
    <StyledProvider.TableContainer>
      <StyledProvider.ScrollContainer>
        <MaterialReactTable
          {...tableConfig}
          columns={columns}
          data={data}
          enableTopToolbar={false}
          renderTopToolbarCustomActions={() => (
            <Box m={0.5}>
              <TitleContainer title="Prestadores" />
            </Box>
          )}
          initialState={{
            density: "compact",
          }}
        />
      </StyledProvider.ScrollContainer>
    </StyledProvider.TableContainer>
  );
};

export default ProviderInUserTable;
